var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('v-container',[_c('v-row',{staticClass:"mt-8",attrs:{"justify":"center"}},[_c('h1',[_vm._v("This application will replace Knack in the future")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }